import { SanityPrintShopBase } from '@data/sanity/queries/types/shop'
import { deleteCookie, getCookie, setCookie } from '@lib/cookie'

const printShopCookieKey = 'printShop'

/**
 * Gets print shop cookie content.
 */
export const getPrintShopCookie = () => {
  const printShopCookie = getCookie(printShopCookieKey)

  if (!printShopCookie) {
    return null
  }

  return JSON.parse(printShopCookie) as SanityPrintShopBase
}

/**
 * Sets print shop cookie content.
 */
export const setPrintShopCookie = (printShop: SanityPrintShopBase) => {
  // 1 month
  const cookieTimeout = 31 * 24 * 60 * 60 * 1000

  setCookie(printShopCookieKey, printShop, {
    expires: new Date(Date.now() + cookieTimeout),
  })
}

/**
 * Removes print shop cookie.
 */
export const removePrintShopCookie = () => {
  deleteCookie(printShopCookieKey)
}
